import React, { useState } from 'react';
import {
    Box,
    Collapse,
    ToggleButton,
    Typography
} from '@mui/material';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

type PropsType = {
    sx: any;
    showJobs: boolean;
    showTenants: boolean;
    showOnlyAccepted: boolean;
    showCarriers: boolean;
    showNonCarriers: boolean;
    setShowOnlyAccepted: (f: (v: boolean) => boolean) => void;
    setShowTenants: (f: (v: boolean) => boolean) => void;
    setShowCarriers: (f: (v: boolean) => boolean) => void;
    setShowNonCarriers: (f: (v: boolean) => boolean) => void;
    setShowJobs: (f: (v: boolean) => boolean) => void;
};
export default function MapSettings({
    sx,
    showOnlyAccepted,
    setShowOnlyAccepted,
    showJobs,
    setShowJobs,
    showTenants,
    setShowTenants,
    showCarriers,
    setShowCarriers,
    showNonCarriers,
    setShowNonCarriers
}: PropsType) {
    return (
        <Box sx={sx}>
            <ToggleButtonGroup
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    backgroundColor: 'transparent',
                    '& .MuiToggleButtonGroup-grouped': {
                        border: 'none'
                    },
                    '& .MuiToggleButtonGroup-firstButton, & .MuiToggleButtonGroup-middleButton, & .MuiToggleButtonGroup-lastButton': {
                        marginLeft: 0
                    }
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <ToggleButton
                        value="isTenant"
                        color="primary"
                        selected={false}
                        onClick={() => setShowTenants((v) => !v)}
                        sx={{ width: 140, height: 40, borderRadius: '4px' }}
                    >
                        {
                            showTenants
                                ? <CheckBox fontSize="small" />
                                : <CheckBoxOutlineBlank fontSize="small" />
                        }
                        <Typography variant="body1" sx={{ pt: '1px', px: '4px' }}>
                            FÖRETAG
                        </Typography>
                    </ToggleButton>
                    <Collapse in={showTenants} orientation="horizontal" timeout={150} sx={{ display: 'flex' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                            <ToggleButton
                                value="isAccepted"
                                color="primary"
                                selected={false}
                                sx={{
                                    width: 190,
                                    height: 40,
                                    backgroundColor: 'rgba(0, 0, 0, 0.03)',
                                    borderRadius: '0'
                                }}
                                onClick={() => setShowOnlyAccepted((v) => !v)}
                            >
                                {
                                    showOnlyAccepted
                                        ? <CheckBox fontSize="small" />
                                        : <CheckBoxOutlineBlank fontSize="small" />
                                }
                                <Typography variant="caption" sx={{ pt: '1px', px: '4px' }}>
                                    Endast accepterade
                                </Typography>
                            </ToggleButton>
                            <ToggleButton
                                value="isCarrier"
                                color="primary"
                                selected={false}
                                onClick={() => setShowCarriers((v) => !v)}
                                sx={{
                                    width: 145,
                                    height: 40,
                                    backgroundColor: 'rgba(0, 0, 0, 0.03)',
                                    borderRadius: '0'
                                }}
                            >
                                {
                                    showCarriers
                                        ? <CheckBox fontSize="small" />
                                        : <CheckBoxOutlineBlank fontSize="small" />
                                }
                                <Typography variant="caption" sx={{ pt: '1px', px: '4px' }}>
                                    Transportörer
                                </Typography>
                            </ToggleButton>
                            <ToggleButton
                                value="isNonCarrier"
                                color="primary"
                                selected={false}
                                onClick={() => setShowNonCarriers((v) => !v)}
                                sx={{
                                    width: 90,
                                    height: 40,
                                    backgroundColor: 'rgba(0, 0, 0, 0.03)',
                                    borderRadius: '0'
                                }}
                            >
                                {
                                    showNonCarriers
                                        ? <CheckBox fontSize="small" />
                                        : <CheckBoxOutlineBlank fontSize="small" />
                                }
                                <Typography variant="caption" sx={{ pt: '1px', px: '4px' }}>
                                    Köpare
                                </Typography>
                            </ToggleButton>
                        </Box>
                    </Collapse>
                </Box>
                <ToggleButton
                    value="isJob"
                    color="primary"
                    selected={false}
                    onClick={() => setShowJobs((v) => !v)}
                    sx={{ width: 140, height: 40, borderRadius: '4px' }}
                >
                    {
                        showJobs
                            ? <CheckBox fontSize="small" />
                            : <CheckBoxOutlineBlank fontSize="small" />
                    }
                    <Typography variant="body1" sx={{ pt: '1px', pl: '4px' }}>
                        UPPDRAG
                    </Typography>
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
